/* eslint-disable @typescript-eslint/ban-types -- TODO: Clean code !!! */
/* eslint-disable @typescript-eslint/no-explicit-any -- TODO: Clean code !!! */
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { FormSchemas } from './form-schemas';
import { FormioUtils } from '@formio/angular';
import { Form } from 'formiojs';
const COMPONENT_MAP = {
    string: 'textfield',
    number: 'number',
    boolean: 'checkbox',
    object: 'container',
    array: 'datagrid',
    panel: 'panel'
};
let DynamicFormsService = class DynamicFormsService {
    getForm(type) {
        return FormSchemas.generate(type);
    }
    buildFormFromModel(model) {
        const form = { components: traverseModel(model) };
        return form;
    }
    async generateForm(options = {}) {
        return this.getForm(options.formType);
    }
    async extendFormWithModel(form, model) {
        const modelForm = this.buildFormFromModel(model);
        const fullForm = await new Form(form, {}).ready;
        const fullModelForm = await new Form(modelForm, {}).ready;
        const mergedForm = this.mergeForms(fullForm, fullModelForm);
        return mergedForm.schema;
    }
    mergeForms(fullForm, fullModelForm) {
        const fullFormFlattened = {};
        fullForm.everyComponent((comp) => {
            fullFormFlattened[comp.path] = comp;
        });
        FormioUtils.eachComponent(fullModelForm.getComponents(), (modelComp, modelPath) => {
            if (fullFormFlattened[modelPath]) {
                return;
            }
            let compToAdd;
            let parentComponent;
            do {
                // start with modelComp, and then walk up the tree
                compToAdd = compToAdd ? compToAdd.parent : modelComp;
                const parentPath = compToAdd?.parent?.path || '';
                parentComponent = parentPath ? fullFormFlattened[parentPath] : fullForm;
            } while (compToAdd && !parentComponent);
            if (parentComponent && compToAdd) {
                const addedComp = parentComponent.addComponent(compToAdd.schema);
                if (parentComponent.path) {
                    fullFormFlattened[parentComponent.path] = parentComponent; // update parentComponent reference
                }
                if (addedComp.path) {
                    fullFormFlattened[addedComp.path] = addedComp; // add new component reference
                    // add any new child component references
                    FormioUtils.eachComponent(addedComp.components, (comp, path) => {
                        fullFormFlattened[path] = comp;
                    }, true, parentComponent.path);
                }
            }
        }, false);
        return fullForm;
    }
    // Form.io keeps display-only fields (persistent: false) in the live data model
    // but strips them from its submission; since we save the raw data (not the
    // submission), drop those fields here so they are never persisted.
    stripNonPersistentFields(data, components) {
        const nonPersistentKeys = collectNonPersistentKeys(components);
        return nonPersistentKeys.length ? _.omit(data, nonPersistentKeys) : data;
    }
    handleEvent(event, form) {
        let changed = false;
        if (event.type === 't20s.addComponent') {
            const childId = event.component.id;
            const mapping = {};
            FormioUtils.eachComponent(form.components, (component) => {
                mapping[component.id] = component;
                if (component.id === childId) {
                    const { newKey, type } = event.data.__addNewProp;
                    const spliceStart = -3; // TODO: Keaton: rename
                    mapping[component.parent.parent.id].components.splice(spliceStart, 0, { type, key: newKey });
                    delete event.data.__addNewProp;
                    changed = true;
                    return changed;
                }
            }, true, '', {});
        }
        return changed;
    }
};
DynamicFormsService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], DynamicFormsService);
export { DynamicFormsService };
// Walk a form.io component tree (including layout nesting via `components` and
// `columns`) collecting the keys of every component marked `persistent: false`.
function collectNonPersistentKeys(components = []) {
    return _.reduce(components, (keys, component) => {
        if (component?.persistent === false && component.key) {
            keys.push(component.key);
        }
        if (_.isArray(component?.components)) {
            keys.push(...collectNonPersistentKeys(component.components));
        }
        if (_.isArray(component?.columns)) {
            component.columns.forEach((column) => keys.push(...collectNonPersistentKeys(column?.components)));
        }
        return keys;
    }, []);
}
function traverseModel(model) {
    const components = [];
    _.forEach(model, (value, key) => {
        const { type, overrides } = determineComponentTypeNeeded(value);
        let schema = getComponentSchema(type, key, overrides);
        if (schema) {
            if (hasNested(type)) {
                const prettyLabel = _.startCase(key);
                schema.components.push(...traverseModel(type === 'array' ? value[0] : value));
                const dataSchema = schema;
                schema = getComponentSchema('panel', `${key}-Panel`, {
                    label: prettyLabel,
                    title: prettyLabel,
                    collapsed: true,
                    collapsible: true,
                    components: [dataSchema]
                });
            }
            components.push(schema);
        }
    });
    return components;
}
function determineComponentTypeNeeded(value) {
    let type = '';
    const overrides = {};
    if (!_.isNil(value)) {
        type = typeof value;
        if (_.isArray(value)) {
            overrides.multiple = true;
            const elementsType = getArrayElementsType(value);
            if (hasNested(elementsType)) {
                // Fix: dynform mishandling Array<object> in some cases
                // datagrid expects 1 schema to use for each 'row', but we don't
                // always want every object to have/require the same properties
                _.assign(overrides, {
                    as: 'json',
                    editor: 'ace',
                    customClass: 'json-list',
                    defaultValue: { property: 'value' }
                });
                type = 'textarea';
            }
            else {
                type = elementsType;
            }
        }
    }
    return { type, overrides };
}
function hasNested(type) {
    return _.includes(['object', 'array'], type);
}
function getComponentSchema(type, key, overrides = {}) {
    // for components with nested components, need to make sure there is an array to push them to
    if (hasNested(type) && !_.isArray(overrides.components)) {
        overrides.components = [];
    }
    return _.merge({ key, label: _.startCase(key), type: _.get(COMPONENT_MAP, type, type) }, overrides);
}
function getArrayElementsType(model) {
    return _.reduce(model, (acc, value) => {
        if (!_.isNil(value)) {
            acc = typeof value;
            if (acc === 'object' && _.isArray(value)) {
                acc = 'array';
            }
        }
        return acc;
    }, 'string');
}
